<template>
  <div>
    <div class="max-diff relative bg-white box-border">
      <div v-for="(item, index) in options" style="height: 246px;" :class="`absolute bg-white left-0 top-0 w-full overflow-y-auto z-${index+1 === curPage ? 10 : 0}`" :key="index">
        <h5>({{index+1}}) 选项组合{{index+1}}</h5>
        <div class="flex justify-between">
          <!-- 列的头 -->
          <div v-for="(rowH, idx) in orderHeader" :class="`flex-${rowH.prop === 'richText'?'1':'1'} overflow-auto text-center`" :key="idx">
            <h5>{{rowH.label}}</h5>
            <!-- 内容 -->
            <div v-for="(row, i) in itemOptions(item, rowData)" :key="i">
              <!-- 选项 -->
              <span :class="`${isRichText(row)?'option-rich-text':''} option-item flex flex-col`" v-if="rowH.prop === 'text'" @click="checkOption(row)">{{(row[rowH.prop].length>=7?(row[rowH.prop].slice(0,7)+'...'):row[rowH.prop])}}</span>
              <!-- 单选 -->
              <span v-else class="inline-block">
                <el-radio :value="item[rowH.prop]" :label="row.optionId" @input="change($event, rowH.prop, item.rowId, row.value)">{{''}}</el-radio>
              </span>
            </div>
          </div>
        </div>

      </div>
       <!-- 分页 -->
      <footer v-if="options.length" class="bg-card-bg-gray px-4 absolute bottom-2 left-1/2 transform -translate-x-1/2 h-6 leading-24" style="border-radius: 12px;">
        <i @click="forward" :class="`el-icon-arrow-left cursor-${isCanForward ?'pointer':'default'} ${isCanForward?'text-black':'text-theme-black-450'}`"></i>
        <span class="mx-3 select-none">{{curPage}}/{{options.length}}</span>
        <i @click="next" :class="`el-icon-arrow-right cursor-${isCanNext?'pointer':'default'} ${isCanNext?'text-black':'text-theme-black-450'}`"></i>
      </footer>
    </div>
    
  </div>
</template>

<script>
import { saveArr } from '../public/index.js'
export default {
  name: 'MaxDiff',
  inject: ['transformHtml'],
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      //rowData.items 中 colId含义对照表
      COL: {
        BEST: '0', //最重要
        WORST: '1', //最不重要
        OPTION: '2' //选项
      },
      curPage: 1 //当前分页
    }
  },
  computed: {
    //控制列的顺序 左对齐、居中对齐
    orderHeader() {
      const r = {prop: 'text', label: '选项'}
      const cols = [
        {prop: 'best', label: this.rowData.questionDetails.issue.labelBest},
        {prop: 'worst', label: this.rowData.questionDetails.issue.labelWorst}
      ]
      const pos = this.rowData.questionDetails.issue.align // align ： 0=左对齐，1=居中，2=右对齐
      cols.splice(pos, 0, r)
      return cols
    },
    //外层循环list（选项组合1、2、3...）
    options() {
      const list = this.rowData.items.filter(item=>item.colId === this.COL.OPTION)
      return list.map(item => ({
        ...item,
        worst: this.worstOrBestValue(item, this.rowData).worst,
        best: this.worstOrBestValue(item, this.rowData).best
      }))
    },
    //内层循环list (每个选项)
    itemOptions() {
      return function(item, row) {
        const optionIds = item.optionId.split(',')
        const values = item.value.split(',')
        return optionIds.map( (item, index)  => ({
          optionId: item,
          value: values[index],
          richText: this.getRichText(item, row).richText,
          text: this.getRichText(item, row).text
        }))
      }
    },
    //获取选项对应富文本
    getRichText() {
      return function(optionId, row) {
        const item = row.questionDetails.issue.items.find(it => it.id === optionId)?.content
        return {
          richText: item?.richText || '',
          text: item?.text || ''
        }
      }
    },
    //获取最不重要、最重要的optionId
    worstOrBestValue() {
      return function(item, row) {
        const values = row.items.filter(v => v.rowId === item.rowId && v.colId!== this.COL.OPTION)
        return {
          worst: values.find(v => v.colId === this.COL.WORST)?.optionId,
          best: values.find(v => v.colId === this.COL.BEST)?.optionId
        }
      }
    },
    isCanForward() {
      return this.curPage > 1
    },
    isCanNext() {
      return this.curPage < this.options.length
    },
    isRichText() {
      return function (row) {
        return row.text.length>=7 || row.richText.includes('img')
      }
    }
  },
  methods: {
    checkOption(row){
      const {richText} = row
      if(!this.isRichText(row)) {
        return
      }
      this.$alert(`<div>${richText}</div>`, '查看', {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        customClass:'message_box_alert'
      });
    },
    forward() {
      if(!this.isCanForward) {
        return
      }
      this.curPage--
    },
    next() {
      if(!this.isCanNext) {
        return
      }
      this.curPage++
    },
    change(val, type, rowId, value) {
      const colId = type === 'worst' ? this.COL.WORST : this.COL.BEST
      //找到要修改的那一条数据index
      const valueIdx = this.rowData.items.findIndex(item => item.rowId === rowId && item.colId === colId )
      /**
       * 四种情况：
       *  1. rowData.items中存在对应那条数据
       *    1) 与相反逻辑不冲突（相反逻辑指：最不重要和最重要不能为同一个选项）
       *    2) 与相反逻辑冲突
       *  2. rowData.items中不存在对应那条数据 
       *    1) 与相反逻辑不冲突
       *    2) 与相反逻辑冲突
       */
      const checkLogic = () => {
        //rowData.items中找到逻辑相反的那一条数据
        const otherIdx = this.rowData.items.findIndex(item => item.rowId === rowId && item.colId === (colId === this.COL.WORST ? this.COL.BEST : this.COL.WORST) && item.optionId === val )
        if (otherIdx !== -1) {
          this.rowData.items.splice(otherIdx, 1)
        }
      }
      if(valueIdx !== -1) { //存在
        this.rowData.items[valueIdx].optionId = val
        checkLogic()
      } else {  //不存在
        checkLogic()
        this.rowData.items.push({
          colId,
          optionId :  val,
          photos : null,
          rowId,
          value,
          valueRank: null
        })
      }
      this.saveArr()
    },
    saveArr
  }
}
</script>

<style lang="scss" scoped>
.max-diff {
  min-height: 280px;
}
.option-rich-text {
  @apply text-theme cursor-pointer h-10 overflow-hidden whitespace-nowrap;
}

</style>
<style>
.message_box_alert {
  overflow: auto !important;
  height: 100% !important;
}
</style>